module.exports = __webpack_public_path__ + "img/outlet.40dbce21.jpg";